import { FC } from 'react';
import { graphql } from '../../../../../gql';
import { useApiQuery } from '../../../../../query/hooks';
import { useIntl } from 'react-intl';
import { AddItemSelect } from '../../components/AddItemSelect';
import { useModalContext } from '../../../../../modal/ModalContext';

const actionSelect_listActions = graphql(`
	query actionSelect_listActions {
		listAction(filter: { status: { notEq: resolved } }) {
			id
			name
		}
	}
`);

type Props = Readonly<{
	removedIds?: string[];
	onChange: (value: string) => void;
	activityId: string;
}>;

export const AddActionSelect: FC<Props> = ({ removedIds, onChange, activityId }) => {
	const intl = useIntl();
	const { setModal } = useModalContext();
	const { isLoading, data } = useApiQuery(actionSelect_listActions);
	const options = (data?.listAction ?? [])
		.filter((o) => !removedIds || !removedIds.includes(o.id))
		.map((o) => ({ label: o.name, id: o.id }));

	const handleCreateAction = (): void => {
		setModal({
			type: 'createActionAndAddToActivity',
			payload: {
				activityId,
			},
		});
	};

	return (
		<AddItemSelect
			text={intl.formatMessage({ id: 'journey.detail.widget.actions.add' })}
			noItemsText={intl.formatMessage({ id: 'journey.detail.widget.actions.no-actions' })}
			createText={intl.formatMessage({ id: 'journey.detail.widget.actions.create' })}
			isLoading={isLoading}
			options={options}
			onChange={onChange}
			onCreate={handleCreateAction}
		/>
	);
};
